import { Button } from "react-bootstrap"
import ClientListSelect2 from "../ClientList/ClientListSelect2";
import { useState, useEffect, useRef } from "react";
import StaffSelectPopup from "./StaffSelectPopup";
import { useCallback } from "react";
import { useApiClient } from "../../ApiService/useApiClient";


const CheckStaffAvailablity = ({TaskID,SelectClick}) => {

const api = useApiClient();

 const [showModal, setShowModal] = useState(false);
 const [data, setData] = useState(null);
 const [error, setError] = useState(null);
 const isMounted = useRef(true);
 const [isSending, setIsSending] = useState(false);

 useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  const checkbuttonclick = useCallback(async ()=>{


    if (isSending) return
    // update state
    setIsSending(true);

   const URL = "HMCareTask/getavailablestaff/"+TaskID

   //console.log(URL);
   //return null;
       
        await api.get(URL)        
          .then((Response)=>{
            setData(Response.data);
            setShowModal(true);
             // console.log(data);

          }).catch(error => {
              setError(error);     
              //console.log({error})              
          }).finally(()=>{ 
            setIsSending(false)
          });
    
   // alert('ssss');

  },[])

  const closeClientsModal =()=>{

    setShowModal(false);

  }
  const clientSelect =(client)=>{

    
    SelectClick(TaskID,client);
    //console.log(client)
    closeClientsModal()

  }


  return (
    <>
        <Button style={{marginTop:"10px",}} variant="outline-primary" size="sm" onClick={checkbuttonclick} disabled={isSending}>+ Assign</Button>
       
        <StaffSelectPopup
        ClientsModal={showModal}
        clientSelect={clientSelect}
        closeClientsModal={closeClientsModal}
        clients={data}
        title={"Available Carers"}
        />

       

    </>
  )
}

export default CheckStaffAvailablity